const COLOR_NAME_PROPERTY = '_color_name';
const MASTER_NAME_PROPERTY = '_master_name';
const IS_FINAL_SALE_PROPERTY = '_is_final_sale';
const COMPARE_AT_PRICE_PROPERTY = '_compare_at_price';

export const getItemCartProperties = ({ colorName, compareAtPrice, isFinalSale, masterName }) => {
  const finalSaleProperty = isFinalSale ? { [IS_FINAL_SALE_PROPERTY]: isFinalSale } : {};
  const compareAtPriceProperty = compareAtPrice
    ? { [COMPARE_AT_PRICE_PROPERTY]: compareAtPrice }
    : {};
  return {
    [COLOR_NAME_PROPERTY]: colorName,
    [MASTER_NAME_PROPERTY]: masterName,
    ...finalSaleProperty,
    ...compareAtPriceProperty,
  };
};

export const extractCartSkus = (cart) => {
  return cart?.items?.map((item) => item.sku).filter(Boolean) || [];
};
